import {actions} from "./actions";

export function getSetters(dispatch) {
    return {
        setPageNumber: payload => dispatch({ type: actions.SET_PAGE_NUMBER, payload: payload }),
        setTotalSize: payload => dispatch({ type: actions.SET_TOTAL_SIZE, payload: payload }),
        setEventTimelineSearch: payload => dispatch({ type: actions.SET_EVENT_TIMELINE_SEARCH, payload: payload }),
        setAvailableEventTypes: payload => dispatch({ type: actions.SET_AVAILABLE_EVENT_TYPES, payload: payload })
    }
}